import { Resource } from './Resource';
import { SceneDescription } from './SceneDescription';

export class SceneResource extends Resource<SceneDescription> {
  static TypeId: string = 'scene';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return SceneResource.TypeId;
  }
}
